import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback } from 'react';
import { MenuButton } from "./MenuButton";
import { Menu } from "./Menu";
import { Button } from "../Button";
import { IconChevronUpDown } from "@frameio/vapor-icons/build/esm/icons/IconChevronUpDown";
import styled from 'styled-components';
import { theme, whenHovered } from "../../theme";
import { useCallbackRef } from "../../hooks";
import { whenPressed } from "../../theme/utils";
/**
 * MenuSelect
 *
 * Prescribed behavior / appearance for a menu item which
 * should show a Select menu.
 */

export var MenuSelect = React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      content = _ref.content,
      iconBefore = _ref.iconBefore,
      disabled = _ref.disabled,
      details = _ref.details,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ["children", "content", "iconBefore", "disabled", "details", "value"]);

  var _useCallbackRef = useCallbackRef(),
      _useCallbackRef2 = _slicedToArray(_useCallbackRef, 2),
      targetEl = _useCallbackRef2[0],
      setTargetEl = _useCallbackRef2[1];

  var renderIconAfter = useCallback(function () {
    return /*#__PURE__*/React.createElement(SelectButton, {
      forwardedAs: "div",
      size: "small",
      iconAfter: /*#__PURE__*/React.createElement(IconChevronUpDown, null),
      ref: setTargetEl
    }, value);
  }, [setTargetEl, value]);
  return /*#__PURE__*/React.createElement(Menu, {
    content: content,
    anchorElement: targetEl
  }, /*#__PURE__*/React.createElement(MenuButton, _extends({
    ref: forwardedRef,
    iconAfter: renderIconAfter,
    iconBefore: iconBefore,
    details: details,
    disabled: disabled,
    shouldCloseMenuOnSelect: false
  }, other), children));
});
var SelectButton = styled(Button).withConfig({
  displayName: "MenuSelect__SelectButton",
  componentId: "vapor__sc-1y2i18q-0"
})(["cursor:inherit;height:", ";line-height:", ";margin-right:-", ";", "{background-color:", ";}", "{background-color:", ";}"], theme.spaces[24], theme.spaces[24], theme.spaces[4], whenHovered, theme.colors.background.interactive.hover, whenPressed, theme.colors.background.interactive.pressed);